import { Record } from 'immutable';

export default class TermRecord extends Record({
  id: undefined,
  name: '',
  content: '',
}) {
}
